export default __webpack_public_path__ + "static/media/2-6-4.f7bbd1f9.jpg";